import Cookies from 'js-cookie';
import { DEFAULT_REDIRECT_URL } from 'dashboard/constants/globals';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { accountIdFromPath, sanitizeReturnTo } from 'shared/helpers/returnTo';

export const hasAuthCookie = () => {
  return !!Cookies.get('cw_d_session_info');
};

// The landing page to use when there is no deep link to honour: the account
// the user was last on, falling back to the first one they belong to.
const getDefaultAccountPath = user => {
  const { accounts = [], account_id = null } = user || {};
  if (!accounts.length) return '';

  return `accounts/${account_id || accounts[0].id}`;
};

const userBelongsToAccount = (user, accountId) =>
  (user?.accounts || []).some(account => Number(account.id) === accountId);

export const getLoginRedirectURL = ({ returnTo, user }) => {
  // A recorded deep link wins over the default landing page, but only for an
  // account this user is a member of: any other account is refused by
  // validateLoggedInRoutes on arrival, which would bounce them back to login.
  const safeReturnTo = sanitizeReturnTo(returnTo);
  if (safeReturnTo) {
    const accountId = accountIdFromPath(safeReturnTo);
    if (accountId === null || userBelongsToAccount(user, accountId)) {
      return safeReturnTo;
    }
  }

  const accountPath = getDefaultAccountPath(user);
  if (accountPath) {
    return frontendURL(`${accountPath}/dashboard`);
  }
  return DEFAULT_REDIRECT_URL;
};
